import React from 'react'
import PropTypes from 'prop-types'

const PATH_D = 'M5.25 8.75H6.41667V5.25H5.25V8.75ZM6.24896 3.91563'
  + 'C6.36076 3.80382 6.41667 3.66528 6.41667 3.5'
  + 'C6.41667 3.33472 6.36076 3.19618 6.24896 3.08438'
  + 'C6.13715 2.97257 5.99861 2.91667 5.83333 2.91667'
  + 'C5.66806 2.91667 5.52951 2.97257 5.41771 3.08438C5.3059 3.19618 5.25 3.33472 5.25 3.5'
  + 'C5.25 3.66528 5.3059 3.80382 5.41771 3.91563'
  + 'C5.52951 4.02743 5.66806 4.08333 5.83333 4.08333'
  + 'C5.99861 4.08333 6.13715 4.02743 6.24896 3.91563ZM5.83333 11.6667'
  + 'C5.02639 11.6667 4.26806 11.5135 3.55833 11.2073'
  + 'C2.84861 10.901 2.23125 10.4854 1.70625 9.96042'
  + 'C1.18125 9.43542 0.765625 8.81806 0.459375 8.10833C0.153125 7.39861 0 6.64028 0 5.83333'
  + 'C0 5.02639 0.153125 4.26806 0.459375 3.55833'
  + 'C0.765625 2.84861 1.18125 2.23125 1.70625 1.70625'
  + 'C2.23125 1.18125 2.84861 0.765625 3.55833 0.459375C4.26806 0.153125 5.02639 0 5.83333 0'
  + 'C6.64028 0 7.39861 0.153125 8.10833 0.459375'
  + 'C8.81806 0.765625 9.43542 1.18125 9.96042 1.70625'
  + 'C10.4854 2.23125 10.901 2.84861 11.2073 3.55833'
  + 'C11.5135 4.26806 11.6667 5.02639 11.6667 5.83333'
  + 'C11.6667 6.64028 11.5135 7.39861 11.2073 8.10833'
  + 'C10.901 8.81806 10.4854 9.43542 9.96042 9.96042'
  + 'C9.43542 10.4854 8.81806 10.901 8.10833 11.2073'
  + 'C7.39861 11.5135 6.64028 11.6667 5.83333 11.6667Z'

const InfoCircleFilledIcon = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <path d={PATH_D} fill="currentColor" transform="translate(1.1667 1.1667)" />
  </svg>
)

InfoCircleFilledIcon.propTypes = {
  className: PropTypes.string
}

InfoCircleFilledIcon.defaultProps = {
  className: 'tw:h-3.5 tw:w-3.5'
}

export default InfoCircleFilledIcon
